<template>
  <v-expansion-panels v-model="detail_panel" multiple>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div>
          <v-icon>mdi-fire</v-icon><span class="headerTitle">{{ labels.fireRiskDetTitle }}</span>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-text-field
                    v-model="mainForm.unitNo"
                    :label="labels.unitNo"
                    :error-messages="errors.collect('unitNo')"
                    data-vv-name="unitNo"
                    :data-vv-as="labels.unitNo"
                    prefix="#"
                    v-validate="'unit_no|max:30|required'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="mainForm.riskPostCode"
                    :label="labels.riskPostCode"
                    :error-messages="errors.collect('riskPostCode')"
                    data-vv-name="riskPostCode"
                    :data-vv-as="labels.riskPostCode"
                    type="tel"
                    @change="fetchAddress"
                    v-int-mask="{ intScale: 6 }"
                    v-validate="'numeric|max:8'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="mainForm.bldgNo"
                    :label="labels.bldgNo"
                    :error-messages="errors.collect('bldgNo')"
                    data-vv-name="bldgNo"
                    :data-vv-as="labels.bldgNo"
                    v-validate="'max:30|required'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="mainForm.collNo"
                    :label="labels.collNo"
                    :error-messages="errors.collect('collNo')"
                    data-vv-name="collNo"
                    :data-vv-as="labels.collNo"
                    v-validate="updCollNoValidation"
                  ></v-text-field>
                </v-flex>
                <v-flex xs8>
                  <v-text-field
                    v-model="mainForm.interest"
                    :label="labels.interest"
                    :error-messages="errors.collect('interest')"
                    data-vv-name="interest"
                    :data-vv-as="labels.interest"
                    v-validate="'max:100'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="mainForm.riskLoc"
                    :label="labels.riskLoc"
                    :error-messages="errors.collect('riskLoc')"
                    data-vv-name="riskLoc"
                    :data-vv-as="labels.riskLoc"
                    :rows="4"
                    v-validate="'entry'"
                  ></v-textarea>
                </v-flex>
                <v-flex xs4></v-flex>
                <v-flex xs8></v-flex>
                <v-flex xs8>
                  <v-text-field
                    v-model="mainForm.occpy"
                    :label="labels.occpy"
                    :error-messages="errors.collect('occpy')"
                    data-vv-name="occpy"
                    :data-vv-as="labels.occpy"
                    v-validate="'max:40'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4></v-flex>
                <v-flex xs4>
                  <v-autocomplete
                    :items="occpClsList"
                    v-model="mainForm.occpCls"
                    :label="labels.occpCls"
                    item-text="label"
                    item-value="value"
                    data-vv-name="occpCls"
                    :data-vv-as="labels.occpCls"
                    :error-messages="errors.collect('occpCls')"
                    v-validate="'required'"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete
                    :items="distClsList"
                    v-model="mainForm.distCls"
                    :label="labels.distCls"
                    item-text="label"
                    item-value="value"
                    data-vv-name="distCls"
                    :data-vv-as="labels.distCls"
                    :error-messages="errors.collect('distCls')"
                    v-validate="'required'"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4></v-flex>
                <v-flex xs4>
                  <v-autocomplete
                    :items="constnClsList"
                    v-model="mainForm.constnCls"
                    :label="labels.constnCls"
                    item-text="label"
                    item-value="value"
                    data-vv-name="constnCls"
                    :data-vv-as="labels.constnCls"
                    :error-messages="errors.collect('constnCls')"
                    v-validate="'required'"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete
                    :items="occpClsLimList"
                    v-model="mainForm.occpClsLim"
                    :label="labels.occpClsLim"
                    item-text="label"
                    item-value="value"
                    data-vv-name="occpClsLim"
                    :data-vv-as="labels.occpClsLim"
                    :error-messages="errors.collect('occpClsLim')"
                    v-validate="'required'"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    ref="accmLdgPct"
                    data-vv-scope="accmLdgPct"
                    type="tel"
                    v-num-mask="{ negative: false, intScale: 3, decScale: 2 }"
                    v-validate="{ required: true, mask_decimal: 2 }"
                    v-model="mainForm.accmLdgPct"
                    :label="labels.accmLdgPct"
                    :error-messages="errors.collect('accmLdgPct')"
                    data-vv-name="accmLdgPct"
                    :data-vv-as="labels.accmLdgPct"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="driDisabled">
                  <v-autocomplete
                    :items="zoneCodeList"
                    v-model="mainForm.zoneCode"
                    :label="labels.zoneCode"
                    item-text="label"
                    item-value="value"
                    data-vv-name="zoneCode"
                    :data-vv-as="labels.zoneCode"
                    :error-messages="errors.collect('zoneCode')"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="driDisabled">
                  <v-text-field
                    ref="siLim"
                    data-vv-scope="siLim"
                    v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                    v-validate="{ required: true, mask_decimal: 2 }"
                    v-model="mainForm.siLim"
                    :label="labels.siLim"
                    :error-messages="errors.collect('siLim')"
                    data-vv-name="siLim"
                    :data-vv-as="labels.siLim"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4></v-flex>
                <v-flex xs12>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div>
                          <v-icon>mdi-elevation-decline</v-icon><span class="headerTitle">{{ labels.extraRiskLoc }}</span>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex xs8>
                                  <v-textarea
                                    v-model="mainForm.extraRiskLoc"
                                    :error-messages="errors.collect('extraRiskLoc')"
                                    data-vv-name="extraRiskLoc"
                                    :data-vv-as="labels.extraRiskLoc"
                                    :rows="4"
                                    v-validate="'entry'"
                                  ></v-textarea>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div>
                          <v-icon>mdi-home-variant</v-icon><span class="headerTitle">{{ labels.extraFireRisk }}</span>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex xs4>
                                  <v-radio-group v-model="mainForm.ownTent" :mandatory="true" class="ml-3 pa-0" row>
                                    <v-radio :label="labels.owner" value="true"></v-radio>
                                    <v-radio :label="labels.tenant" value="false"></v-radio>
                                  </v-radio-group>
                                </v-flex>
                                <v-flex xs4></v-flex>
                                <v-flex xs4> </v-flex>
                                <v-flex xs4>
                                  <v-text-field
                                    v-model="mainForm.roof"
                                    :label="labels.roof"
                                    :error-messages="errors.collect('roof')"
                                    data-vv-name="roof"
                                    :data-vv-as="labels.roof"
                                    v-validate="'max:20'"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                  <v-text-field
                                    v-model="mainForm.noStorey"
                                    :label="labels.noStorey"
                                    :error-messages="errors.collect('noStorey')"
                                    data-vv-name="noStorey"
                                    :data-vv-as="labels.noStorey"
                                    v-validate="'max:20'"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs4> </v-flex>
                                <v-flex xs4>
                                  <v-text-field
                                    v-model="mainForm.latitude"
                                    :label="labels.latitude"
                                    :error-messages="errors.collect('latitude')"
                                    data-vv-name="latitude"
                                    :data-vv-as="labels.latitude"
                                    v-validate="'max:15'"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                  <v-text-field
                                    v-model="mainForm.longitude"
                                    :label="labels.longitude"
                                    :error-messages="errors.collect('longitude')"
                                    data-vv-name="longitude"
                                    :data-vv-as="labels.longitude"
                                    v-validate="'max:15'"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs4> </v-flex>
                                <v-flex xs4>
                                  <v-text-field
                                    v-model="mainForm.survRpt"
                                    :label="labels.survRpt"
                                    :error-messages="errors.collect('survRpt')"
                                    data-vv-name="survRpt"
                                    :data-vv-as="labels.survRpt"
                                    v-validate="'max:15'"
                                    append-icon="mdi-magnify"
                                    @click:append="getHelpList()"
                                    readonly
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                  <cal-picker v-model="mainForm.survDate" :label="labels.survDate" :disabled="true"></cal-picker>
                                </v-flex>
                                <v-flex xs4 v-if="survRptDetDisabled">
                                  <a class="text-link" @click="doQueryRiskSurvey">Survey Report Details</a>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-dialog v-model="processing" persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                Processing...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="showSurveyReportHelpList" width="1280px">
            <survey-report-help-list
              v-if="showSurveyReportHelpList"
              :apiURI="this.survReportURI"
              @close="showSurveyReportHelpList = false"
              @assign-survey-report="assignValue"
            ></survey-report-help-list>
          </v-dialog>

          <v-dialog v-model="showRiskSurvey" width="1200px" persistent>
            <RiskSurvey @close="showRiskSurvey = false"></RiskSurvey>
          </v-dialog>

          <confirm v-model="promptChangeSurvRpt" @ok="doChangeSurvRpt">
            <p>Confirm change of Survey Report No.?</p>
          </confirm>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayNumber } from '@/utils/number'
import { formatPrice } from '@/utils/index'
import SurveyReportHelpList from './helplist/SurveyReportHelpList'
import { RISK_SURVEY_QUERY_MODE, RISK_SURVEY_TAB } from '@/store/types'
import RiskSurvey from './riskSurveyDet/RiskSurveyDet'
import clone from 'clone'
import { isEqual } from '@/utils/compare'

export default {
  data() {
    return {
      labels: {
        fireRiskDetTitle: 'Fire Risk Details',
        bldgNo: 'Block / House No.',
        unitNo: 'Unit No',
        collNo: 'Collateral No.',
        interest: 'Interest',
        riskLoc: 'Location',
        riskPostCode: 'Postal Code',
        occpy: 'Occupancy',
        occpCls: 'Occupation Class',
        distCls: 'District Class',
        constnCls: 'Construction Class',
        occpClsLim: 'Occupation Class Limit',
        extraRiskLoc: 'Extra Fire Risk Location',
        extraFireRisk: 'Extra Fire Risk Details',
        accmLdgPct: 'Loading %',
        owner: 'Owner',
        tenant: 'Tenant',
        roof: 'Roof Class',
        noStorey: 'No. of Storeys',
        latitude: 'Latitude X',
        longitude: 'Longitude Y',
        survRpt: 'Survey Report No.',
        survDate: 'Survey Date',
        zoneCode: 'Zone',
        siLim: 'Sum Insured Limit'
      },
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        bldgNo: undefined,
        unitNo: undefined,
        collNo: undefined,
        interest: undefined,
        riskLoc: undefined,
        riskPostCode: undefined,
        occpy: undefined,
        occpCls: undefined,
        distCls: undefined,
        constnCls: undefined,
        occpClsLim: undefined,
        extraRiskLoc: undefined,
        accmLdgPct: undefined,
        ownTent: undefined,
        roof: undefined,
        noStorey: undefined,
        latitude: undefined,
        longitude: undefined,
        oldSurvRpt: undefined,
        survRpt: undefined,
        survDate: undefined,
        zoneCode: undefined,
        siLim: 0,
        verCnt: 0
      },
      occpClsList: [],
      distClsList: [],
      constnClsList: [],
      occpClsLimList: [],
      zoneCodeList: [],
      loading: undefined,
      updCollNo: undefined,
      showSurveyReportHelpList: false,
      survReportURI: '',
      showRiskSurvey: false,
      processing: false,
      promptChangeSurvRpt: false,
      selectedSurvRpt: {},
      detail_panel: []
    }
  },
  props: {
    polRisk: Object
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    updCollNoValidation() {
      if (this.updCollNo === true) {
        return 'required|max:13'
      } else {
        return 'max:13'
      }
    },
    checkOccpCls() {
      if (this.occpClsList.includes(this.mainForm.occpCls) && this.mainForm.occpCls !== undefined) {
        return 'required'
      } else {
        return ''
      }
    },
    driDisabled() {
      if (this.polMaster.dri) {
        return false
      } else {
        return true
      }
    },
    survRptDetDisabled() {
      if (this.mainForm.survRpt !== undefined && this.mainForm.survRpt !== '') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    doInit() {
      this.updCollNo = this.polRisk.updCollNo
      this.$store.commit(RISK_SURVEY_TAB, 0)
      this.getPolFireRisk()
      this.survReportURI = this.$store.state.underwriting.policyFireRiskSettings.menu.getSurvMasterHelpList
    },
    async getPolFireRisk() {
      const apiUrl = this.$store.state.underwriting.policyFireRiskSettings.menu.getPolFireRisk
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          // if (result.data.fireOccupancyList) {
          //   this.occpClsList = result.data.fireOccupancyList
          // }

          if (result.data.fireOccpnClsList) {
            this.occpClsList = result.data.fireOccpnClsList
          }

          if (result.data.fireDistrictClsList) {
            this.distClsList = result.data.fireDistrictClsList
          }

          if (result.data.fireConstrnClsList) {
            this.constnClsList = result.data.fireConstrnClsList
          }

          if (result.data.fireOccpnClsLimList) {
            this.occpClsLimList = result.data.fireOccpnClsLimList
          }

          if (result.data.countryZoneList) {
            this.zoneCodeList = result.data.countryZoneList
          }

          if (result.data.polFireRisk.data) {
            this.mainForm.polNo = result.data.polFireRisk.data.polNo
            this.mainForm.renCnt = result.data.polFireRisk.data.renCnt
            this.mainForm.endtCnt = result.data.polFireRisk.data.endtCnt
            this.mainForm.riskGrpNo = result.data.polFireRisk.data.riskGrpNo
            this.mainForm.riskNo = result.data.polFireRisk.data.riskNo
            this.mainForm.bldgNo = result.data.polFireRisk.data.bldgNo
            this.mainForm.unitNo = result.data.polFireRisk.data.unitNo
            this.mainForm.collNo = result.data.polFireRisk.data.collNo
            this.mainForm.interest = result.data.polFireRisk.data.interest
            this.mainForm.riskLoc = result.data.polFireRisk.data.riskLoc
            this.mainForm.riskPostCode = result.data.polFireRisk.data.riskPostCode
            this.mainForm.occpy = result.data.polFireRisk.data.occpy
            this.mainForm.occpCls = result.data.polFireRisk.data.occpCls
            this.mainForm.distCls = result.data.polFireRisk.data.distCls
            this.mainForm.constnCls = result.data.polFireRisk.data.constnCls
            this.mainForm.occpClsLim = result.data.polFireRisk.data.occpClsLim
            this.mainForm.extraRiskLoc = result.data.polFireRisk.data.extraRiskLoc
            this.mainForm.accmLdgPct = formatPrice(result.data.polFireRisk.data.accmLdgPct)
            this.mainForm.ownTent = result.data.polFireRisk.data.ownTent.toString() === '1' ? 'true' : 'false'
            this.mainForm.roof = result.data.polFireRisk.data.roof
            this.mainForm.noStorey = result.data.polFireRisk.data.noStorey
            this.mainForm.latitude = result.data.polFireRisk.data.latitude
            this.mainForm.longitude = result.data.polFireRisk.data.longitude
            this.mainForm.oldSurvRpt = result.data.polFireRisk.data.survRpt
            this.mainForm.survRpt = result.data.polFireRisk.data.survRpt
            this.mainForm.survDate = result.data.polFireRisk.data.survDate
            this.mainForm.zoneCode = result.data.polFireRisk.data.zoneCode
            this.mainForm.siLim = formatDisplayNumber(result.data.polFireRisk.data.siLim)

            if (this.$refs.siLim) {
              // this.$refs.siLim.$el.cleave.setRawValue(this.mainForm.siLim)
            }
            if (this.$refs.accmLdgPct) {
              // this.$refs.accmLdgPct.$el.cleave.setRawValue(this.mainForm.accmLdgPct)
            }
          }
          this.copymainForm = clone(this.mainForm)
          this.hideInitLoading()
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    hideInitLoading() {
      // Set parent policy.initLoading to false
      this.$emit('hide-init-loading')
    },
    async doPolFireRiskSave() {
      try {
        if (this.mainForm.siLim !== undefined || this.mainForm.siLim !== '') {
          this.mainForm.siLim = this.mainForm.siLim.replace(/,/g, '')
        }
        if (isEqual(this.mainForm, this.copymainForm) === true) {
          return true
        } else {
          const result = await this.$store.dispatch('savePolFireRisk', this.mainForm)
          if (result) {
            return true
          } else {
            return false
          }
        }
      } catch (err) {
        return false
      }
    },
    async fetchAddress() {
      const apiUrl = this.$store.state.underwriting.policyFireRiskSettings.menu.address
      if (apiUrl) {
        try {
          const expand = {
            postCode: this.mainForm.riskPostCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.mainForm.bldgNo = data.add1 // Block No.
            this.copymainForm.bldgNo = data.add1
            if (data.add2 !== data.add4) { // changes for OS-1235
              this.mainForm.riskLoc = data.add1 + ' ' + data.add4
            } else {
              this.mainForm.riskLoc = data.add1
            }
            this.copymainForm.riskLoc = this.mainForm.riskLoc
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doQueryRiskSurvey() {
      this.processing = true
      this.$store.commit(RISK_SURVEY_QUERY_MODE)
      const data = {
        item: {
          survNo: this.mainForm.survRpt,
          verCnt: this.mainForm.verCnt,
          polNo: ''
        }
      }
      this.$store.dispatch('reviewSurveyMaster', data).then((result) => {
        if (result) {
          this.$store.dispatch('reviewSurveyDetails', data).then((result2) => {
            if (result2) {
              this.processing = false
              this.showRiskSurvey = true
            }
          })
        }
      })
    },
    doChangeSurvRpt() {
      this.mainForm.survRpt = this.selectedSurvRpt.survNo
      this.mainForm.verCnt = this.selectedSurvRpt.verCnt
      this.mainForm.survDate = this.selectedSurvRpt.survDate
    },
    getHelpList() {
      this.showSurveyReportHelpList = true
    },
    assignValue(data) {
      this.selectedSurvRpt = data
      if (this.mainForm.survRpt && data.survNo !== this.mainForm.survRpt) {
        this.promptChangeSurvRpt = true
      } else {
        this.doChangeSurvRpt()
      }
      this.showSurveyReportHelpList = false
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyFireRiskSettings.init !== 1) {
      this.$store.dispatch('policyFireRiskInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  created() {
    // if (this.polMaster.dri) {
    //   this.driDisabled = true
    // } else {
    //   this.driDisabled = false
    // }
  },
  components: {
    SurveyReportHelpList,
    RiskSurvey
  },
  mixins: [MessageMixin]
}
</script>

<style lang="scss">
.text-link {
  text-decoration: underline;
}
</style>
